import React, { Component } from 'react';
import Table from '../../../../components/_table/Table/Table';
import Button from '../../../../components/Button';
import Input from '../../../../components/input/Input/Input';
import Select from '../../../../components/input/Select/Select';
import {
  TAG_DETAIL_RELATED_PRODUCT_LIST_SEARCH_KEYWORD_TYPE_SELECT_LIST,
  TAG_RELATED_ITEM_TYPE_TEXT,
} from '../../../../constants/service/app/tagConstants';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import {
  TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
  TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL,
} from '../../../../store/modules/tag/models';
import './TagHistoryRelatedItemList.scss';

class TagHistoryRelatedItemList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  getList = (option) => {
    const { tagRelatedItemType, getTagHistoryRelatedItemList } = this.props;

    getTagHistoryRelatedItemList({
      tagRelatedItemType,
      ...option,
    });
  };

  render() {
    const { tagRelatedItemType, relatedItemList, setData, columns, getProductSubCategoryList } = this.props;
    const { list, searchData, pagination } = relatedItemList;
    const { searchKeyword } = searchData;

    return (
      <div className="tag-history-content tag-history-related-item-list">
        <div className="related-item-list-search-box">
          <div className="related-item-cnt">
            연결된 {TAG_RELATED_ITEM_TYPE_TEXT[tagRelatedItemType]} 리스트 ({pagination.totalCnt})
          </div>

          <Select
            className="tag-group-id-list-select"
            list={TAG_DETAIL_RELATED_PRODUCT_LIST_SEARCH_KEYWORD_TYPE_SELECT_LIST[tagRelatedItemType]}
            onChange={(value) =>
              setData({
                path: ['tagHistory', 'relatedItemList', tagRelatedItemType, 'searchData', 'searchKeyword', 'type'],
                value,
              })
            }
            defaultValue={searchKeyword.type}
            value={searchKeyword.type}
            isTable={false}
          />

          <Input
            value={searchKeyword.text}
            onChange={(value) =>
              setData({
                path: ['tagHistory', 'relatedItemList', tagRelatedItemType, 'searchData', 'searchKeyword', 'text'],
                value,
              })
            }
            onPressEnter={() =>
              this.getList({
                searchOption: searchData,
              })
            }
            placeholder="키워드 검색"
            maxLength={30}
            size="large"
          />

          <Button
            color="primary"
            text="검색"
            onClick={() =>
              this.getList({
                searchOption: searchData,
              })
            }
          />

          <Button
            color="light"
            text="초기화"
            onClick={() => {
              this.getList({
                searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL,
              });
              setData({
                path: ['tagHistory', 'relatedItemList', tagRelatedItemType, 'searchData'],
                value: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
              });
            }}
          />
        </div>

        <Table
          columns={(utils) =>
            columns({
              ...utils,
              tagRelatedItemType,
              getProductSubCategoryList,
            })
          }
          rowKey={(record) => record.id}
          pagination={pagination}
          list={list}
          size="small"
          scroll={{ x: true }}
          bordered={true}
          getList={(option) =>
            this.getList({
              ...option,
            })
          }
        />
      </div>
    );
  }
}

export default TagHistoryRelatedItemList;
